/**
 * in order to make the string compatible with CCP search,
 * Node JS Lowercase => İşlem =>i̇şlem
 * CCP Elasticsearch Lowercase => İşlem =>işlem
 * In order to map them properly and keep them searchable by lowercase, we need to handle this mapping
 * @param string
 */
export const covertToCCPSearchLowerCase = (string: string) => {
  const turkishUppercaseToLowercaseMap: Record<string, string> = {
    İ: 'i',
    Ş: 'ş',
    Ğ: 'ğ',
    Ü: 'ü',
    Ö: 'ö',
    Ç: 'ç',
  };
  string = string.replace(/(([İŞĞÜÇÖ]))+/g, (letter) => turkishUppercaseToLowercaseMap[letter]);
  return string.toLowerCase();
};
